const $ = jQuery.noConflict();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		$('body').on('click', '.video-mobile-link', function () {
			$('.video-link').trigger('click');
		});
		$('body').on('click', '.video-link', function (event) {
			event.preventDefault();			
			const src = $(this).data('video-src');
			const framSrc = $(this).closest('.acf-block').find('.video-frame__iframe-embed');
			framSrc.attr('src', src);
			const videoWrapper = $(this).closest('.acf-block').find('.video-popup__wrapper');
			if (!videoWrapper.hasClass('active')) {
				const iframe = $(
					'.video-popup__wrapper .video-frame__iframe-embed'
				);
				iframe.attr('tabindex', '0');
				iframe.attr('aria-hidden', 'false');
				if (iframe[0].src.includes('?')) {
					iframe[0].src += '&autoplay=1';
				} else {
					iframe[0].src += '?autoplay=1';
				}
				videoWrapper.addClass('active');
				videoWrapper.show();
				$('.block-hero-centered').addClass('video-active');
				$('body').addClass('lock-scroll');
			}
		});
		$('body').on('click', '.video-popup__close', function () {
			const videoWrapper = $(this).closest('.video-popup__wrapper');
			if (videoWrapper.hasClass('active')) {
				const iframe = $(
					'.video-popup__wrapper .video-frame__iframe-embed'
				);
				iframe.attr('tabindex', '-1');
				iframe.attr('aria-hidden', 'true');
				iframe.attr('src', '');
				videoWrapper.removeClass('active');
				videoWrapper.hide();
				$('.block-hero-centered').removeClass('video-active');
				$('body').removeClass('lock-scroll');
			}
		});
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
